import { render, staticRenderFns } from "./ReferralIntrodue.vue?vue&type=template&id=2753a30f&"
import script from "./ReferralIntrodue.vue?vue&type=script&lang=js&"
export * from "./ReferralIntrodue.vue?vue&type=script&lang=js&"
import style0 from "./ReferralIntrodue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports